import {AbstractModelFactory} from '@projectstorm/react-canvas-core';
import {DiagramEngine} from '@projectstorm/react-diagrams-core';
import {DataSidePortModel} from "./DataSidePortModel";

export class DataSidePortFactory extends AbstractModelFactory<DataSidePortModel, DiagramEngine> {
    constructor() {
        super('sideout');
    }

    generateModel(): DataSidePortModel {
        return new DataSidePortModel({
            name: 'unknown'
        });
    }
}
